import _slicedToArray from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { faCircleCheck } from "@fortawesome/pro-light-svg-icons";
import { faEye } from "@fortawesome/pro-regular-svg-icons";
import useCsvUpload from "../../hooks/useCsvUpload";
import AwesomeIcon from "../AwesomeIcon";
import CSVModal from "../CSVModal";
import { useState } from "react";
function ValidationView() {
  var _state$result, _state$result2, _state$result4, _state$result5, _state$result6;
  var _useCsvUpload = useCsvUpload(),
    _useCsvUpload2 = _slicedToArray(_useCsvUpload, 2),
    state = _useCsvUpload2[0],
    dispatch = _useCsvUpload2[1];
  var filePath = (_state$result = state.result) === null || _state$result === void 0 || (_state$result = _state$result.data) === null || _state$result === void 0 ? void 0 : _state$result.file_path;
  var mrn = (_state$result2 = state.result) === null || _state$result2 === void 0 || (_state$result2 = _state$result2.data) === null || _state$result2 === void 0 ? void 0 : _state$result2.new_patient_reports;
  var _useState = useState(null),
    selectedFile = _useState[0],
    setSelectedFile = _useState[1];
  var handlePreview = function handlePreview() {
    var _state$result3;
    setSelectedFile((_state$result3 = state.result) === null || _state$result3 === void 0 || (_state$result3 = _state$result3.data) === null || _state$result3 === void 0 ? void 0 : _state$result3.file);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CSVModal, {
    type: "upload",
    selectedFile: selectedFile,
    setSelectedFile: setSelectedFile
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "px-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-[400px,100px,200px] gap-x-3 text-left"
  }, /*#__PURE__*/React.createElement("p", {
    className: "opacity-50 text-md text-left font-semibold h-[42px] content-center"
  }, "File Name"), /*#__PURE__*/React.createElement("p", {
    className: "opacity-50 text-md text-left font-semibold h-[42px] content-center"
  }, "MRN"), /*#__PURE__*/React.createElement("p", {
    className: "opacity-50 text-md text-left font-semibold h-[42px] content-center"
  }, "Status"), /*#__PURE__*/React.createElement("p", {
    className: "overflow-clip text-left"
  }, filePath, /*#__PURE__*/React.createElement("span", {
    onClick: handlePreview,
    className: "text-gray-500 text-sm ml-2",
    title: "Preview"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    className: "cursor-pointer hover:text-teal-100 text-teal-200 ml-2",
    name: faEye
  }))), /*#__PURE__*/React.createElement("p", {
    className: "text-left"
  }, mrn), /*#__PURE__*/React.createElement("span", {
    className: "inline-flex gap-2 items-start"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faCircleCheck,
    className: "text-teal-400 mr-2 pt-1"
  }), /*#__PURE__*/React.createElement("p", null, "Valid Format")), /*#__PURE__*/React.createElement("div", {
    className: "grid grid-cols-[300px,100px] py-5 text-left"
  }, /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "Patients to be created"), /*#__PURE__*/React.createElement("p", {
    className: ""
  }, (_state$result4 = state.result) === null || _state$result4 === void 0 || (_state$result4 = _state$result4.data) === null || _state$result4 === void 0 ? void 0 : _state$result4.new_patient_reports), /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "Existing patient to be updated"), /*#__PURE__*/React.createElement("p", {
    className: ""
  }, (_state$result5 = state.result) === null || _state$result5 === void 0 || (_state$result5 = _state$result5.data) === null || _state$result5 === void 0 ? void 0 : _state$result5.existing_patients), /*#__PURE__*/React.createElement("p", {
    className: ""
  }, "Failed entries"), /*#__PURE__*/React.createElement("p", {
    className: ""
  }, (_state$result6 = state.result) === null || _state$result6 === void 0 || (_state$result6 = _state$result6.data) === null || _state$result6 === void 0 ? void 0 : _state$result6.invalid_patient_reports))))));
}
export default ValidationView;